import React from 'react';
import { motion } from 'framer-motion';
import { ResumeData } from '../types/resume.types';
import ContactDropdown from './ContactDropdown';
import ToolsDropdown from './ToolsDropdown';

interface HeaderProps {
  data: ResumeData;
}

const Header: React.FC<HeaderProps> = ({ data }) => {
  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 bg-white/90 dark:bg-gray-900/90 backdrop-blur-md border-b border-gray-200 dark:border-gray-700 lg:left-64"
    >
      <div className="section-padding py-2 sm:py-3 md:py-4">
        <div className="flex items-center justify-between">
          {/* Brand area removed - icon now in contact dropdown */}
          <div></div>

          {/* Right side actions */}
          <div className="flex items-center space-x-3">
            {/* Contact Dropdown */}
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <ContactDropdown data={data} />
            </motion.div>

            {/* Tools Dropdown */}
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <ToolsDropdown />
            </motion.div>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;